import * as fromAccount from './account/account.reducer';
import * as fromCabinet from './cabinet/cabinet.reducer';
import * as fromPatient from './patient/patient.reducer';
import * as fromRecord from './record/record.reducer';
import * as fromSpecies from './species/species.reducer';
import * as fromRouter from '@ngrx/router-store';
import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from 'src/environments/environment';


export interface State {
  router: fromRouter.RouterReducerState;
  account: fromAccount.AccountState;
  cabinets: fromCabinet.CabinetState;
  patients: fromPatient.PatientState;
  records: fromRecord.RecordState;
  species: fromSpecies.SpeciesState;
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer,
  account: fromAccount.reducer,
  cabinets: fromCabinet.reducer,
  patients: fromPatient.reducer,
  records: fromRecord.reducer,
  species: fromSpecies.reducer
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
